(function () {
  var TRANSITION_MS = 380;

  function initProductInfoTabs(root) {
    if (!root || root.dataset.tabsReady === 'true') return;
    root.dataset.tabsReady = 'true';

    var tabs = root.querySelectorAll('[data-product-info-tab]');
    var panels = root.querySelectorAll('[data-product-info-panel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-product-info-tab');

        tabs.forEach(function (btn) {
          var isActive = btn === tab;
          btn.classList.toggle('is-active', isActive);
          btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var isActive = panel.getAttribute('data-product-info-panel') === target;
          panel.classList.toggle('is-active', isActive);
          if (isActive) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      });
    });
  }

  function getInnerHeight(content) {
    var inner = content.querySelector('.product-info-collapsible__inner') || content;
    return inner ? inner.scrollHeight : content.scrollHeight;
  }

  function clearTransitionTimer(content) {
    if (content._collapseTimer) {
      window.clearTimeout(content._collapseTimer);
      content._collapseTimer = null;
    }
  }

  function expandContent(root, content) {
    clearTransitionTimer(content);
    content.removeAttribute('hidden');
    content.setAttribute('aria-hidden', 'false');
    content.classList.add('is-animating');

    // Start collapsed, then grow
    content.style.maxHeight = '0px';
    content.style.opacity = '0';
    // reflow
    void content.offsetHeight;

    var target = getInnerHeight(content);
    content.style.maxHeight = target + 'px';
    content.style.opacity = '1';

    content._collapseTimer = window.setTimeout(function () {
      if (root.classList.contains('is-open')) {
        content.style.maxHeight = 'none';
        content.classList.remove('is-animating');
      }
      content._collapseTimer = null;
    }, TRANSITION_MS + 40);
  }

  function collapseContent(root, content) {
    clearTransitionTimer(content);
    content.classList.add('is-animating');
    content.setAttribute('aria-hidden', 'true');

    // Pin current height so we can animate down to 0
    var current = content.style.maxHeight === 'none' || !content.style.maxHeight
      ? getInnerHeight(content)
      : content.scrollHeight;
    content.style.maxHeight = current + 'px';
    content.style.opacity = '1';
    void content.offsetHeight;

    content.style.maxHeight = '0px';
    content.style.opacity = '0';

    content._collapseTimer = window.setTimeout(function () {
      if (!root.classList.contains('is-open')) {
        content.setAttribute('hidden', '');
        content.classList.remove('is-animating');
      }
      content._collapseTimer = null;
    }, TRANSITION_MS + 40);
  }

  function closeCollapsible(root) {
    if (!root || !root.classList.contains('is-open')) return;
    var toggle = root.querySelector('[data-product-info-toggle]');
    var content = root.querySelector('[data-product-info-content]');
    root.classList.remove('is-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (content) collapseContent(root, content);
  }

  function closeSiblingCollapsibles(root) {
    var group =
      root.closest('[data-accordion-group]') ||
      root.closest('.collection-faq-section__list') ||
      null;

    if (!group) return;

    group.querySelectorAll('[data-product-info-collapsible]').forEach(function (item) {
      if (item !== root) closeCollapsible(item);
    });
  }

  function initProductInfoCollapsible(root) {
    if (!root || root.dataset.collapsibleReady === 'true') return;
    root.dataset.collapsibleReady = 'true';

    var toggle = root.querySelector('[data-product-info-toggle]');
    var content = root.querySelector('[data-product-info-content]');
    if (!toggle || !content) return;

    // Initial closed state styles (when not open by default)
    if (!root.classList.contains('is-open')) {
      content.style.maxHeight = '0px';
      content.style.opacity = '0';
      content.setAttribute('aria-hidden', 'true');
    } else {
      content.removeAttribute('hidden');
      content.style.maxHeight = 'none';
      content.style.opacity = '1';
      content.setAttribute('aria-hidden', 'false');
    }

    toggle.addEventListener('click', function () {
      var willOpen = !root.classList.contains('is-open');

      // Accordion: opening one closes others in the same group
      if (willOpen) {
        closeSiblingCollapsibles(root);
      }

      root.classList.toggle('is-open', willOpen);
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');

      if (willOpen) {
        expandContent(root, content);
      } else {
        collapseContent(root, content);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-product-info-tabs]').forEach(initProductInfoTabs);
    document.querySelectorAll('[data-product-info-collapsible]').forEach(initProductInfoCollapsible);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function () {
    // allow re-init after editor reload
    document.querySelectorAll('[data-product-info-collapsible]').forEach(function (el) {
      el.dataset.collapsibleReady = 'false';
    });
    document.querySelectorAll('[data-product-info-tabs]').forEach(function (el) {
      el.dataset.tabsReady = 'false';
    });
    initAll();
  });
})();
